var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-none d-xl-block"},[_c('section',{staticClass:"call-buton"},[_c('a',{staticClass:"cc-calto-action-ripple",attrs:{"href":"tel:"}},[_c('img',{staticClass:"image-icon",attrs:{"src":require("@/assets/icon/zalo-icon-circle.png"),"alt":""}})])])])
}]

export { render, staticRenderFns }